import {error} from "services-comun/modules/browser/log";

import {Auth} from "../services/auth";
import {IConfig} from "../config";
import dominio from "services-comun-ed/modules/portal/ed";
import {ESubdominio} from "services-comun-ed/modules/services/portadillas/interface";

export class NavBar {
    /* STATIC */
    private static instancia?: NavBar;

    public static async load(auth: Auth, config: IConfig, state?: any): Promise<void> {
        if (this.instancia==undefined) {
            const navegacion = document.getElementById('navbar');
            if (navegacion!=null) {
                this.instancia = new this(navegacion, auth, config);
            }
        }
    }

    public static async unload(): Promise<void> {
        this.instancia?.clean();
        this.instancia = undefined;
    }

    public static async updateEstado(state?: any): Promise<void> {

    }

    /* INSTANCE */
    public constructor(private readonly navegacion: HTMLElement, private readonly auth: Auth, private readonly config: IConfig) {
        this.init()
            .then(async ()=>{
            })
            .catch(async (err)=>{
                error(`Error cargando plantilla "navbar"`, err);
            });
    }

    private async init(): Promise<void> {
        const plantilla = require("panel-templates/templates/components/navbar.pug");
        require("panel-templates/css/sections/comun/navbar.scss");

        let permisos_administracion = {
            usuarios: this.auth.usuario?.permisos.includes('secciones.administracion.usuarios.listar'),
            roles: this.auth.usuario?.permisos.includes('secciones.administracion.roles.listar'),
            publicidad: this.auth.usuario?.permisos.includes('secciones.administracion.publicidad'),
        }

        let permisos_redaccion = {
            noticias: this.auth.usuario?.permisos.some(permiso => permiso.startsWith('secciones.redaccion.articulos.listar')),
            redactores: this.auth.usuario?.permisos.includes('secciones.redaccion.redactores.editar') || this.auth.usuario?.permisos.includes('secciones.redaccion.redactores.administrar'),
            tags: this.auth.usuario?.permisos.includes('secciones.redaccion.tags.fusionar'),
            portadillas: this.auth.usuario?.permisos.some(permiso => permiso.startsWith('secciones.redaccion.portadillas.destacar')),
            encuestas: this.auth.usuario?.permisos.includes('secciones.redaccion.encuestas'),
            barraSeo: this.auth.usuario?.permisos.includes('secciones.redaccion.barraSeo'),
            videos: this.auth.usuario?.permisos.includes('secciones.redaccion.videos'),
        }

        // todo activar flags en función de los permisos del usuario
        const contenido = plantilla({
            permisos_administracion,
            redaccion: permisos_redaccion.noticias || permisos_redaccion.redactores || permisos_redaccion.tags || permisos_redaccion.portadillas || permisos_redaccion.portadillas || permisos_redaccion.videos,
            permisos_redaccion,
            foto: NavBar.instancia?.auth.usuario?.avatar??'img/icons/png/no-photo-profile.png',
            fotoDominio: dominio.get(dominio.toDominio(ESubdominio.www))+'/img/estadio-deportivo.svg',
        });
        requestAnimationFrame(()=>{
            this.navegacion.innerHTML = contenido;

            const navbar = document.getElementById("navbar");
            if (navbar!=null) {
                const a = navbar.getElementsByTagName("a");
                const len = a.length;
                for (let i=0;i<len;i++) {
                    const actual = a.item(i);
                    if (actual!=null) {
                        if (!actual.classList.contains("navbar-brand")) {
                            actual.onclick = (ev)=>{
                                this.navegar(ev, false);
                            }
                        } else {
                            actual.onclick = (ev)=>{
                                this.navegar(ev, true);
                            }
                        }
                    }
                }
                const logOut = document.getElementById("logOutButton");
                if(logOut){
                    logOut.onclick = (ev) => {
                        this.auth.signOut();
                        this.navegar(ev, true);
                    }
                }
            }
        });
    }

    private navegar(ev: MouseEvent, home: boolean): void {
        ev.preventDefault();
        const href: string = (ev.target as any).pathname;
        if (href!=window.location.pathname && (home || href!=`${this.config.router.basePath}/`)) {
            window.history.pushState({}, "", href);
            this.auth.router.ejecutar()
                .then(async ()=>{})
                .catch(async ()=>{});
        }
    }

    private clean(): void {
        const navbar = document.getElementById("navbar");
        if (navbar!=null) {
            const a = navbar.getElementsByTagName("a");
            const len = a.length;
            for (let i=0;i<len;i++) {
                const actual = a.item(i);
                if (actual!=null) {
                    actual.onclick = null;
                }
            }
        }
        requestAnimationFrame(()=>{
            this.navegacion.innerHTML = "";
        });
    }
}
